import React, {useCallback, useEffect, useState, useRef} from "react";
import axios from "axios";
import PropTypes from 'prop-types';
import { Translate } from "../Translator";
import PdfPng from '../../Assets/Pdf.png';
import { Button } from "react-bootstrap";
import { OAuthApiStartPolling, OAuthApiStopPolling } from "../../ExternalApi/OAuthApi"
import { ConfigurationApiForward } from "../../ExternalApi/ConfigurationApi"
import IntegrationWizardDots from "../IntegrationWizard/IntegrationWizardDots"

const DatasourceHelpScout = (props) => {
    
    const [mRepainter, SetRepainter] = useState(false); 
    const [mWaitingForState, SetWaitingForState] = useState("")
    const [mError, SetError] = useState("") 
    const [mOAuthWindow, SetOAuthWindow] = useState(null) 

    useEffect(() => {
        SetReady()
        SetRepainter(!mRepainter)
      }, []); 

    const UpdateDatasourceSetting = (aNewValue, aIdentifier) =>
    {
        props.IntegrationSettings.DatasourceSettings[aIdentifier] = aNewValue
        SetRepainter(!mRepainter)

        SetReady()
    }

    const SetReady = () => 
    {
        props.OnSetReady(props.IntegrationSettings.DatasourceSettings["AppID"] && props.IntegrationSettings.DatasourceSettings["AppSecret"] && props.IntegrationSettings.DatasourceSettings.RefreshToken)
    }

    async function GetTokens(aAuthorizationCode) 
    {
        let Result = await ConfigurationApiForward(
            props.SecurityToken, 
            "https://api.helpscout.net/v2/oauth2/token", 
            "POST", 
            "client_id=" + props.IntegrationSettings.DatasourceSettings["AppID"] + "&client_secret=" + props.IntegrationSettings.DatasourceSettings["AppSecret"] + "&grant_type=authorization_code&code=" + aAuthorizationCode, 
            "application/json", 
            "application/x-www-form-urlencoded")
        if (Result != null)
        {
            UpdateDatasourceSetting(Result.data.access_token, "AccessToken")
            UpdateDatasourceSetting(Result.data.refresh_token, "RefreshToken")
        }
        else
        {
            SetError("Failed to retrieve tokens")
        }

        SetWaitingForState("")
    }

    const OAuthPollResult = (aResult, aValue, aOAuthWindow) =>
    {
        try 
        { 
            if (aOAuthWindow !== null)
            {
                aOAuthWindow.close() 
                aOAuthWindow = null
                SetOAuthWindow(null)
            }
        } 
        catch {}

        if (aResult)
        {
            console.log("OAuthPollResult success: " + JSON.stringify(aValue))
            if (aValue.Code && aValue.ResponseUrl)
            {
                GetTokens(aValue.Code)
            }
            else
            {
                SetError("Failed to authenticate. No authorizationcode found")  
            }
        }
        else
        {
            console.log("OAuthPollResult error: " + JSON.stringify(aValue))  
            SetError("Failed to authenticate")          
        }
    }

    const RandomState = () => 
    {
        let Result = "client2020WEB"

        var characters = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ'
        for ( var i = 0; i < 27; i++ ) 
        {
            Result += characters.charAt(Math.floor(Math.random() * characters.length))
        }
        
        return Result
    }

    const StartOAuth = () =>
    {
        const State = RandomState()

        const OAuthUrl = "https://secure.helpscout.net/authentication/authorizeClientApplication" +
            "?client_id=" + props.IntegrationSettings.DatasourceSettings["AppID"] +
            "&state=" + State
        const OAuthWindow = window.open(OAuthUrl, "_blank", 'popup=yes,titlebar=0,left=' + ((screen.availWidth - 750)/2)  + ',top=' + ((screen.availHeight - 750)/2)  + ',width=750,height=750')
        SetOAuthWindow(OAuthWindow)
        OAuthApiStartPolling(State, OAuthPollResult, OAuthWindow)

        SetWaitingForState(State)
    }

    const StopOAuth = () =>
    {
        OAuthApiStopPolling()
        try 
        { 
            if (mOAuthWindow !== null)
            {
                mOAuthWindow.close() 
                SetOAuthWindow(null)
            }
        } 
        catch {}        

        SetWaitingForState("")
    }

    const BrandingId = sessionStorage.getItem("BrandingId")

    const OAuthBody = props.IntegrationSettings.DatasourceSettings.RefreshToken ?
        //Authorization OK
        <div className="scriptitembody">
            {Translate("$Application connection token received succesfully").replace("$Application","HelpScout")}
        </div> :
        (mError ?
            //Authorization failed. Show error and connect button
            <div className="scriptitembody">
                <Button variant="primary" className={BrandingId === "enreach" ? "brandbuttonprimary" : "brandbuttonkeeporiginalstyle"} onClick={() => StartOAuth()} type="submit">{Translate("Connect")}</Button><br/>
                <div>{mError}</div>
            </div> :
            (mWaitingForState ?
                //Waiting for authorization. Show dot counter and cancel button
                <div className="scriptitembody">
                    <Button variant="danger" className={BrandingId === "enreach" ? "brandbuttonprimary" : "brandbuttonkeeporiginalstyle"} onClick={() => StopOAuth()} type="submit">{Translate("Cancel")}</Button><br/><br/>
                    <div>{Translate("Waiting for OAUTH verification")}<IntegrationWizardDots/></div>
                </div> :
                <div className="scriptitembody">
                    {props.IntegrationSettings.DatasourceSettings["AppID"] && props.IntegrationSettings.DatasourceSettings["AppSecret"] ?
                        <Button variant="primary" className={BrandingId === "enreach" ? "brandbuttonprimary" : "brandbuttonkeeporiginalstyle"} onClick={() => StartOAuth()} type="submit">{Translate("Connect")}</Button> :
                        <Button variant="primary" className={BrandingId === "enreach" ? "brandbuttonprimary" : "brandbuttonkeeporiginalstyle"} disabled type="submit">{Translate("Connect")}</Button>}
                </div> 
            )
        )

    return (
        <span>
            <div className="wizardfieldname">{Translate("App ID").toUpperCase()} <span className="redtext">*</span></div>
            <div className="wizardfieldvalue"><input autoComplete="helpscout.appid" placeholder="" type="text" size="100" value={props.IntegrationSettings.DatasourceSettings["AppID"] || ""} onChange={evt => UpdateDatasourceSetting(evt.target.value, "AppID")} className="wizardinputfield"/></div>
            <div className="wizardfieldname">{Translate("App secret").toUpperCase()} <span className="redtext">*</span></div>
            <div className="wizardfieldvalue"><input autoComplete="helpscout.appsecret" placeholder="" type="text" size="100" value={props.IntegrationSettings.DatasourceSettings["AppSecret"] || ""} onChange={evt => UpdateDatasourceSetting(evt.target.value, "AppSecret")} className="wizardinputfield"/></div>
            {OAuthBody}
        </span>
    )
}

DatasourceHelpScout.propTypes = {
    SecurityToken: PropTypes.string,
    DatasourceData: PropTypes.object,
    IntegrationSettings: PropTypes.object,
    OnSetReady: PropTypes.func
}   

export default DatasourceHelpScout